import { ArticlesList } from "./ArticlesList";
import { HighlightCategory } from "./HighlightCategory";

import styles from "./BlogMain.module.scss";
import { SearchEngine } from "./SearchEngine";
import { useBlogPageContext } from "@/helpers/contexts/BlogPageContext";

export const BlogMain = () => {
  const data = useBlogPageContext();
  if (!data) return null;
  const { pagination, blog, articles, clientPagination, notFound, search } = data;
  return (
    <div className={styles.wrapper}>
      <SearchEngine
        isSearch={!notFound && !!search}
        pagination={clientPagination}
        filteredArticles={articles}
        isLoading={false}
      >
        {pagination.page === 1 &&
          blog.highlightCategories.map((category) => (
            <HighlightCategory key={category.url} category={category} />
          ))}

        <ArticlesList pagination={pagination} list={articles} heading="Recently added" />
      </SearchEngine>
    </div>
  );
};
